import isPerksGO from "@irati/deals/helpers/deals/isPerksGO";
import isAppOnly from "@irati/deals/helpers/deals/isAppOnly";
import { isDealUnavailable } from "@irati/deals/helpers/deals/isDealUnavailable";
import { isUserDOBRequired } from "@irati/deals/helpers/deals/redemptionEvents/dateOfBirth";
export var shouldShowRedemptionButton = function (deal) {
    return !isPerksGO(deal) && !isUserDOBRequired(deal) && !isAppOnly(deal) && !isDealUnavailable(deal);
};
